import {useContext} from 'react';

import UploadContext from '../../contexts/UploadContext';

const useUpload = () => {
  return useContext(UploadContext);
};

export default useUpload;
